/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-05, 10:55:28
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
// Mapa wszystkich możliwych błędów, które zwróci API w przypadku statusu HTTP 406 (Not Acceptable)

/* eslint-disable key-spacing */
export default {
  // number
  'number|type':         'Przepraszamy. Panel Online nie jest w tym momencie dostępny. Trwa aktualizacja danych [101].',
  'number|length':       'Nieprawidłowa długość numeru - numer powinien mieć 9 cyfr',
  'number|required':     'Nie podano numeru telefonu',
  'number|not_found':    'Przepraszamy. Panel Online nie jest w tym momencie dostępny. Trwa aktualizacja danych [102].',
  'number|blocked':      'Przepraszamy. Panel Online nie jest w tym momencie dostępny. Trwa aktualizacja danych [103].',
  'number|login_register_blocked' : 'Przepraszamy. Panel Online nie jest w tym momencie dostępny. Trwa aktualizacja danych [104].',
  // password
  'password|type':       '???',
  'password|number':     'Hasło powinno zawierać co najmniej jedną cyfrę',
  'password|letter':     'Hasło powinno zawierać co najmniej jedną dużą literę',
  'password|latin':      'Hasło nie może zawierać polskich znaków',
  'password|length':     'Hasło musi mieć co najmniej 8 znaków',
  'password|required':   'Nie podano hasła',
  'password|whitespace': 'Hasło nie może zawierać "białych znaków" (np. spacja)',
  // sms code
  'code|type':           '???',
  'code|length':         'Nieprawidłowa dugość kodu SMS',
  'code|required':       'Nie podano kodu SMS',
  'code|not_found':      'Podany kod jest nieprawidłowy',
  'code|verification':   'Podany kod został już wykorzystany',
  'code|code_expired':   'Ważność kodu SMS wygasła',
  // invoice
  'invoce|not_found':   'Trwa aktualizacja bazy danych. Faktura pojawi się do 24 godz.',
  // complains
  'content|required':   'Treść zgłoszenia nie może być pusta',
  // rodo terms
  'terms|required':     'Nie wszystkie wymagane pola zostały zaznaczone',
};



// WEBPACK FOOTER //
// ./src/services/utils/errorMessages.js